import { createActions } from 'redux-actions';

export const { updateOptionSources } = createActions('UPDATE_OPTION_SOURCES');
